export default __webpack_public_path__ + "static/media/virtual-runway.b524dba9.svg";